var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gt-layout',[_c('template',{slot:"logo"},[_c('logo')],1),_c('template',{slot:"setting"},[_c('router-link',{attrs:{"to":"/"}},[_c('el-dropdown-item',[_vm._v("其他")])],1)],1),_c('template',{slot:"navbar-dropdown"},[_c('span'),_c('router-link',{attrs:{"to":"/"}},[_c('el-dropdown-item',[_vm._v("首页")])],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }